import { useState } from "react";
import { toast } from "sonner";
import { Lock, LogIn } from "lucide-react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { API } from "../../lib/api";
import { useLang } from "../../lib/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";
import axios from "axios";

const LoginScreen = ({ onLogin }) => {
  const { t } = useLang();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem('authToken', res.data.token);
      onLogin(res.data.token);
    } catch (err) {
      setError(err.response?.data?.detail || t('loginError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-background flex items-center justify-center p-4">
      <div className="absolute top-6 right-6">
        <LanguageSwitcher />
      </div>
      <div className="glass rounded-2xl p-8 max-w-md w-full border border-border">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center mb-4">
            <Lock className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold" data-testid="login-title">{t('adminLogin')}</h1>
          <p className="text-text-secondary text-sm mt-1">{t('loginSubtitle')}</p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="email">{t('email')}</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@example.com" className="mt-2 bg-surface-highlight border-border" required data-testid="login-email" />
          </div>
          <div>
            <Label htmlFor="password">{t('password')}</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="********" className="mt-2 bg-surface-highlight border-border" required data-testid="login-password" />
          </div>
          {error && (
            <div className="p-3 bg-error/10 border border-error/30 rounded-lg text-error text-sm" data-testid="login-error">{error}</div>
          )}
          <Button type="submit" disabled={loading} className="w-full bg-gradient-to-r from-primary to-secondary hover:opacity-90 py-6" data-testid="login-submit-btn">
            {loading ? (
              <span className="flex items-center gap-2"><span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />{t('loggingIn')}</span>
            ) : (
              <span className="flex items-center gap-2"><LogIn className="w-4 h-4" />{t('loginBtn')}</span>
            )}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;
